export default __webpack_public_path__ + "static/proximity-dont-ded708a2ec2bf19b6ce7174ab3817808.png";